import Popover from "@material-ui/core/Popover";
import FilterIcon from "assets/icons/icon.png";
import React from "react";
import {
  PopoverActionCol,
  PopoverBox,
  PopoverButton,
  PopoverWrapper,
} from "./Theme";
import { Box } from "@material-ui/core";

const TableColumnFilter = ({ options, onChange, value, allSelected }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleFilterChange = (value) => {
    onChange(value);
  };

  return (
    <div>
      <PopoverButton onClick={handleClick} style={{ position: "relative" }}>
        <img src={FilterIcon} alt="filter" />
        {!allSelected && value?.length > 0 && (
          <Box
            sx={{
              width: 6,
              height: 6,
              backgroundColor: "#ff3668",
              borderRadius: "50%",
              position: "absolute",
              top: -3,
              right: -4,
              zIndex: 100,
            }}
          ></Box>
        )}
      </PopoverButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: `center`,
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={""}
      >
        <PopoverWrapper>
          {options?.map((option, index) => (
            <PopoverActionCol
              key={option?.value}
              onClick={() => handleFilterChange(option?.value)}
            >
              <PopoverBox
                checked={allSelected || value?.includes(option?.value)}
              />
              <span>{option?.label}</span>
            </PopoverActionCol>
          ))}
        </PopoverWrapper>
      </Popover>
    </div>
  );
};

export default TableColumnFilter;
